/***************************************************************
 * 他箇所との連携用
 **************************************************************/
/**
 * テナント情報（ID、会社名）取得API リクエスト
 */
export class OrganizationNameRequest {
  /** テナントID */
  public id: string = "";
}
/**
 * テナント情報（ID、会社名）取得API レスポンス
 */
export class OrganizationNameResponse {
  /** テナントID */
  public id: string = "";
  /** 組織名 */
  public organizationName: string = "";
}